export function waitForElementAndCopy(sourceClass: string, targetClass: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const targetNode = document.body;
    const config: MutationObserverInit = { childList: true, subtree: true };

    const callback = (mutationsList: MutationRecord[], observer: MutationObserver) => {
      const sourceNode = document.querySelector(`.${sourceClass}`);
      if (sourceNode) {
        observer.disconnect(); // 監視を停止

        const targetElement = document.querySelector(`.${targetClass}`);
        if (targetElement) {
          const clonedNode = sourceNode.cloneNode(true);
          targetElement.appendChild(clonedNode);
          resolve();
        } else {
          reject();
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);

    // タイムアウトを設定（例：10秒）
    setTimeout(() => {
      observer.disconnect();
      reject(new Error(`タイムアウト: '${sourceClass}' が見つかりませんでした。`));
    }, 10000);
  });
}
